import "./DropdownMenuMobile.scss";

import React, {
  useCallback,
  useContext
} from "react";

import { UiStateContext } from "design-system/shared/contexts/ui-state/UiStateContext";
import { MainNavigationItem } from "design-system/shared/models/app-data-model";

import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionSummary,
  Box,
  Typography
} from "@mui/material";

import SubNavDropdownContent from "../sub-nav-dropdown-content/SubNavDropdownContent";

export type DropdownMobileProps = {
  navItem: MainNavigationItem;
  subnavIndex: number;
};

const DropdownMenuMobile: React.FC<DropdownMobileProps> = ({ navItem, subnavIndex }: DropdownMobileProps) => {
  const uiStateContext = useContext(UiStateContext);

  const toggleDropdown = useCallback(
    (dropdownData: MainNavigationItem): void => {
      if (uiStateContext.subNavOpenIndex === subnavIndex) {
        uiStateContext.setSubNavOpenIndex?.(-1);
      } else {
        uiStateContext.setDropDownData?.(dropdownData);
        uiStateContext.setSubNavOpenIndex?.(subnavIndex);
      }
    },
    [subnavIndex, uiStateContext]
  );

  return <Accordion disableGutters expanded={uiStateContext.subNavOpenIndex === subnavIndex} elevation={0} className='dropdown-mobile'>
    <AccordionSummary
      expandIcon={<ExpandMore className='expand-icon'/>}
      onClick={() => toggleDropdown(navItem)}
    >
      <Typography className='dropdown-menu-title' sx={{ width: '100%' }}>
        {navItem.title}
      </Typography>
    </AccordionSummary>
    <Box className="dropdown-menu-content">
      <SubNavDropdownContent />
    </Box>
  </Accordion> 
};

export default DropdownMenuMobile;
